(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shipping-calculator-cart"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    var root = document.querySelector("[data-cart-calculator]");
    if (!root) return;
    var shippingZip = document.getElementById("frete-cep-cart");
    var shippingCountry = document.getElementById("pais-simulator-cart");
    var shippingProvince = document.getElementById("estados-simulator-cart");
    var shippingMessage = document.getElementById("frete-error-cart");
    var freteLista = document.getElementById("frete-results-cart");
    var calcularBtn = document.getElementById("frete-calcular-cart");
    if (!shippingZip || !calcularBtn) return;

    var config = {
      errorMessage: root.dataset.errorMessage || "CEP não encontrado, tente novamente.",
      freeShippingText: root.dataset.freeShippingText || "Grátis"
    };

    function formatMoney(cents, format) {
      if (typeof window.MinimogSettings !== "undefined" && window.MinimogSettings.money_format) {
        format = window.MinimogSettings.money_format;
      }
      if (!format) format = "R$ [[amount]]";
      var value = (cents / 100).toFixed(2).replace(".", ",").replace(/(\d)(?=(\d{3})+,)/g, "$1.");
      var moneyFormat = window.MinimogSettings && window.MinimogSettings.money_format ? window.MinimogSettings.money_format : format;
      moneyFormat = moneyFormat.replace(/\{\{amount\}\}/g, value).replace(/\{\{amount_no_decimals\}\}/g, Math.round(cents / 100)).replace(/\{\{amount_with_comma_separator\}\}/g, value);
      return moneyFormat;
    }

    function calcularDiasUteis(dataEntrega) {
      var hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      var fim = new Date(dataEntrega);
      fim.setHours(0, 0, 0, 0);
      if (fim <= hoje) return null;
      var dias = 0;
      var atual = new Date(hoje);
      while (atual < fim) {
        atual.setDate(atual.getDate() + 1);
        var diaSemana = atual.getDay();
        if (diaSemana !== 0 && diaSemana !== 6) dias++;
      }
      return dias;
    }

    // Prazos fixos para fretes manuais (sem delivery_days nem delivery_date)
    var prazosFixos = {
      "Envio Econômico": "8 a 12 dias úteis",
      // Adicione outras transportadoras manuais aqui se precisar:
      // "Nome exato da transportadora": "X dias úteis",
    };

    function formatarPrazo(rate) {
      if (rate.delivery_days != null && rate.delivery_days > 0) {
        return rate.delivery_days === 1 ? "1 dia útil" : rate.delivery_days + " dias úteis";
      }
      if (rate.delivery_date) {
        var dias = calcularDiasUteis(rate.delivery_date);
        if (dias != null && dias > 0) {
          return dias === 1 ? "1 dia útil" : dias + " dias úteis";
        }
      }
      // Fallback: prazo fixo por nome
      if (prazosFixos[rate.name]) {
        return prazosFixos[rate.name];
      }
      return null;
    }

    // Event delegation — remove listener anterior antes de registrar novo
    if (window._freteCartInputHandler) {
      document.removeEventListener("input", window._freteCartInputHandler);
    }
    if (window._freteCartClickHandler) {
      document.removeEventListener("click", window._freteCartClickHandler);
    }

    window._freteCartInputHandler = function(e) {
      if (e.target.id !== "frete-cep-cart") return;
      var digits = e.target.value.replace(/\D/g, "");
      if (digits.length > 8) digits = digits.slice(0, 8);
      var formatted = digits;
      if (digits.length > 5) formatted = digits.slice(0, 2) + "." + digits.slice(2, 5) + "-" + digits.slice(5);
      else if (digits.length > 2) formatted = digits.slice(0, 2) + "." + digits.slice(2);
      e.target.value = formatted;
      if (digits.length === 8) {
        shippingZip = document.getElementById("frete-cep-cart");
        shippingProvince = document.getElementById("estados-simulator-cart");
        shippingCountry = document.getElementById("pais-simulator-cart");
        shippingMessage = document.getElementById("frete-error-cart");
        freteLista = document.getElementById("frete-results-cart");
        if (shippingZip) buscarCep(digits);
      }
    };
    document.addEventListener("input", window._freteCartInputHandler);

    window._freteCartClickHandler = function(e) {
      if (e.target.id !== "frete-calcular-cart") return;
      e.preventDefault();
      var zip2 = document.getElementById("frete-cep-cart");
      if (!zip2) return;
      var cepLimpo = zip2.value.replace(/\D/g, "");
      if (cepLimpo.length < 8) {
        var msg2 = document.getElementById("frete-error-cart");
        if (msg2) { msg2.textContent = "CEP inválido"; msg2.style.display = "block"; }
        return;
      }
      buscarCep(cepLimpo);
    };
    document.addEventListener("click", window._freteCartClickHandler);

    function buscarCep(cepLimpo) {
      shippingMessage.textContent = "";
      shippingMessage.style.display = "none";
      freteLista.style.display = "block";
      freteLista.innerHTML = '<div style="display:flex;justify-content:center;padding:20px;"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="animation:spin 1s linear infinite"><style>@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}</style><circle cx="12" cy="12" r="10" stroke="#d9d9d9" stroke-width="3" fill="none"/><path d="M12 2a10 10 0 0 1 10 10" stroke="#414141" stroke-width="3" fill="none" stroke-linecap="round"/></svg></div>';
      shippingZip.blur();

      fetch("https://brasilapi.com.br/api/cep/v2/" + cepLimpo)
        .then(function(r) { if (!r.ok) throw new Error("CEP não encontrado"); return r.json(); })
        .then(function(dados) {
          if (dados.state) {
            var ufMap = { "AC": "Acre", "AL": "Alagoas", "AP": "Amapa", "AM": "Amazonas", "BA": "Bahia", "CE": "Ceara", "DF": "Distrito Federal", "ES": "Espirito Santo", "GO": "Goias", "MA": "Maranhao", "MT": "Mato Grosso", "MS": "Mato Grosso do Sul", "MG": "Minas Gerais", "PA": "Para", "PB": "Paraiba", "PR": "Parana", "PE": "Pernambuco", "PI": "Piaui", "RJ": "Rio de Janeiro", "RN": "Rio Grande do Norte", "RS": "Rio Grande do Sul", "RO": "Rondonia", "RR": "Roraima", "SC": "Santa Catarina", "SP": "Sao Paulo", "SE": "Sergipe", "TO": "Tocantins" };
            shippingProvince.value = ufMap[dados.state] || dados.state;
            getRatesCart();
          } else {
            freteLista.innerHTML = "";
            freteLista.style.display = "none";
            shippingMessage.textContent = config.errorMessage;
            shippingMessage.style.display = "block";
          }
        })
        .catch(function() {
          freteLista.innerHTML = "";
          freteLista.style.display = "none";
          shippingMessage.textContent = config.errorMessage;
          shippingMessage.style.display = "block";
        });
    }

    function getRatesCart() {
      shippingMessage.style.display = "none";
      freteLista.style.display = "block";
      freteLista.innerHTML = '<div style="display:flex;justify-content:center;padding:20px;"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="animation:spin 1s linear infinite"><style>@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}</style><circle cx="12" cy="12" r="10" stroke="#d9d9d9" stroke-width="3" fill="none"/><path d="M12 2a10 10 0 0 1 10 10" stroke="#414141" stroke-width="3" fill="none" stroke-linecap="round"/></svg></div>';

      var params = new URLSearchParams({
        "shipping_address[country]": shippingCountry.value,
        "shipping_address[province]": shippingProvince.value,
        "shipping_address[zip]": shippingZip.value.replace(/\D/g, "")
      });

      fetch("/cart/shipping_rates.json?_easygift_internal=true&" + params.toString(), {
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" }
      })
        .then(function(r) { return r.json(); })
        .then(function(d) {
          if (d.shipping_rates && d.shipping_rates.length) {
            freteLista.innerHTML = "";
            var menorPrazo = d.shipping_rates.reduce(function(menor, r) {
                var dias = r.delivery_days != null ? parseInt(r.delivery_days) : 9999;
                return dias < menor ? dias : menor;
              }, 9999);
            for (var i = 0; i < d.shipping_rates.length; i++) {
              var rate = d.shipping_rates[i];
              var prazo = formatarPrazo(rate);
              var valorFrete = rate.price;
              if (valorFrete === "0.00" || valorFrete == null) {
                valorFrete = config.freeShippingText;
              } else {
                valorFrete = formatMoney(parseFloat(valorFrete) * 100, null);
              }
              var freteItem = document.createElement("div");
              freteItem.className = "frete-item" + (i === 0 ? " selected" : "");
              var isMaiRapido = rate.delivery_days != null && parseInt(rate.delivery_days) > 0 && parseInt(rate.delivery_days) === menorPrazo;
              var avisoModal = rate.name === "Correios PAC Mini" ? ' · Mais lento' : '';
              freteItem.innerHTML =
                '<div class="frete-radio"></div>' +
                '<div class="frete-item__info">' +
                  '<p class="frete-item__name">' + rate.name + (isMaiRapido ? ' <span class="frete-tag-rapido">🚀 Mais rápido</span>' : '') + '</p>' +
                  (prazo ? '<span class="frete-item__delivery">' + prazo + avisoModal + '</span>' : '') +
                '</div>' +
                '<div class="frete-item__price">' + valorFrete + '</div>';
              freteItem.addEventListener("click", function() {
                freteLista.querySelectorAll(".frete-item").forEach(function(el) { el.classList.remove("selected"); });
                this.classList.add("selected");
              });
              freteLista.appendChild(freteItem);
            }
            var notice = document.createElement("div");
            notice.className = "frete-notice";
            notice.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>Você poderá escolher a opção de entrega desejada na próxima etapa do checkout.';
            freteLista.appendChild(notice);
          } else {
            freteLista.innerHTML = "";
            freteLista.style.display = "none";
            shippingMessage.textContent = config.errorMessage;
            shippingMessage.style.display = "block";
          }
        })
        .catch(function(err) {
          console.error(err);
          freteLista.innerHTML = "";
          freteLista.style.display = "none";
          shippingMessage.textContent = config.errorMessage;
          shippingMessage.style.display = "block";
        });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
